/**
 * @module Dashboard
 */

import { Component, Input } from '@angular/core';
import { DashboardLayoutClass } from '@class/dashboardLayout.class';
import { ItemColor } from '@functions/item.functions';

@Component({
  selector: 'app-dashboard-layout-columns',
  templateUrl: './dashboard-layout-columns.component.html',
  styleUrls: ['./dashboard-layout-columns.component.css']
})
export class DashboardLayoutColumnsComponent {

  @Input() dashboardLayout: DashboardLayoutClass;

  color = ItemColor('dashboards');
  
  constructor() {}

  receiveValue(columns: number) {
    this.dashboardLayout.change({ columns: columns });
  }

}
